import $ from 'jquery'
import TarifActe from '@/views/parametres/tarifications/tarif-acte'
import TarifChambre from '@/views/parametres/tarifications/tarif-chambre'
import TarifObservation from '@/views/parametres/tarifications/tarif-observation'
import TarifAdmission from '@/views/parametres/tarifications/tarif-admission'
import TarifConsommable from '@/views/parametres/tarifications/tarif-consommable'

export default {
	name: 'tarifications',
	components: {
		TarifActe, TarifChambre, TarifObservation,
		TarifAdmission, TarifConsommable
	},
	props: [],
	data() {
		return {
			// Groupe assurance
			group_assur_select: '',
			// assurance_select: '',
			assurance_select: {
				compagnie: 'Choisir une assurance',
				compagnie_id: -1
			},
			can_show_assur: false,

			tarif_filter: [
				{
                    libelle: 'Tous',
                    id: '0',
                },
                {
                    libelle: 'Consultations généralistes',
                    id: '1',
                },
                {
                    libelle: 'Consultations spécialistes',
                    id: '2',
                },
				{
                    libelle: 'Chirurgies',
                    id: '3',
                },
                {
                    libelle: 'Analyses',
                    id: '4',
                },
				{
                    libelle: 'Examens',
                    id: '5',
                },
				{
                    libelle: 'Médicaments',
                    id: '6',
                },
				{
                    libelle: 'Consommables',
                    id: '7',
                },
				{
                    libelle: 'Bilan de santé',
                    id: '8',
                },
				{
					libelle: 'Actes',
                    id: '9',
				},
				{
					libelle: 'Chambres',
                    id: '10',
				},
				{
					libelle: 'Observations',
                    id: '11',
				},
				{
					libelle: 'Admissions',
                    id: '12',
				}
            ],

			moment_consultation: [
				{
					id: 1,
					denomination: 'Jour'
				},
				{
					id: 2,
					denomination: 'Nuit'
				},
				{
					id: 3,
					denomination: 'Férié'
				},
				{
					id: 4,
					denomination: 'Garde'
				}
			],

			filtre_tarif: '',

			type_prestation_to_add: '',

			// ###### v-model Tarif Consultation
			c_prestation: {
				type_consultation_id: 0,
				categorie_consultation: 0,
				id: 0,
				libelle: '',
				lettre_cle: '',
				coef: '',
				moment: {
					id: '',
					denomination: ''
				},
				prix_non_assure: '',
				prix_assure_clinique: '',
				groupe_assur_id: '',
				assurance_id: '',
				code_prod_assurance: ''
			},
			is_new: true,
			is_edit: false,
			can_add_moment: false,
			can_add_coef: true,
			show_prix: 0,				//	0 => None   |  1 => Only CAT  |  2 => CAT & ONMT   |  3 => Only INAM
			can_show_prix: true,
			can_show_lettre_cle: true,
			can_show_param_pu: true,

			// ###### v-model Autre Tarif ( Chirurgies, Analyses... )
			autre_prestation: {
				id: 0,
				libelle: '',
				lettre_cle: '',
				coef: '',
				prix_non_assure: '',
			},

			// >>>>>>>>>>  Tarif Consultation Générale
			tarif_gen_loading: true,
			tarif_gen_empty: false,
			fields: [
				'prestations', { key: 'prix_non_assure', label: 'Prix (non assuré)' },
				'actions'
			],
			p_fields: [
				'prestations', { key: 'prix_non_assure', label: 'Prix (non assuré)' },
			],

			fields_chirurg: [
				'prestations', { key: 'prix_non_assure', label: 'Prix (non assuré)' },
				'actions'
			],
			p_fields_chirurg: [
				'prestations', { key: 'prix_non_assure', label: 'Prix (non assuré)' },
				'actions'
			],
			filter: "",
			filter_1: "",
			filter_2: "",
			filter_3: "",
			filter_4: "",
			filter_5: "",
			filter_chirug: [],
			perPage: 20,
			print_per_page: -1,
			currentPage: 1,
			// >>>------------------------------------

			// >>>>>>>>> Tarif Consultation Specialiste
			tarif_spec_loading: true,
			tarif_spec_empty: false,

			// >>>>>>>>>	Tarif Analyses
			tarif_analyse_loading: true,
			tarif_analyse_empty: false,

			// >>>>>>>>>	Tarif Examens Para
			tarif_exam_loading: true,
			tarif_exam_empty: false,

			// >>>>>>>>>	Tarif Chirurgies
			tarif_chirurgie_loading: true,
			tarif_chirurgie_empty: false,

			// >>>>>>>>>	Tarif Médicaments
			tarif_medicament_loading: true,
			tarif_medicament_empty: false,

			// >>>>>>>>>	Bilan de santé
			tarif_bilan_sante_loading: true,
			tarif_bilan_sante_empty: false,

			save_loading: false,
			btn_disable: false,
			loading: false,
			options: { placeholder: "Choisir une option" },

			del_categorie_consultation: 0,

			// PU CAT / ONMT
			pu_cat_onmt: {
				type_prestation: '',
				id: 0,
				libelle: '',
				lettre_cle: '',
				pu_cat: '',
				pu_onmt: '',
				pu_inam: '',
				groupe_assur_id: '',
				assurance_id: ''
			},
			pu_loading: true,

			// >>>>>>>>>>>>... Suppression
			tarif_to_be_deleted: {
				tarif_id: 0,
				libelle: ''
			},
			is_confirm: false,
			del_loading: false,

            all_checked: false,
            one_is_checked: [],
            text_grey: [],
			is_all_assur: false,

			is_printing_consul_gen: false,
			is_printing_consul_spec: false,
			is_printing_analyse: false,
			is_printing_examen: false,
			is_printing_med: false,
            is_printing_chirurgie: false,
			is_printing_bilan: false,
            filename: '',
            p_printing: '',

			editing_acte_tarif_data: {},
			editing_chambre_tarif_data: {},
			editing_observation_tarif_data: {},
			editing_admission_tarif_data: {},
			editing_consommable_tarif_data: {},
			is_zero: false,
			can_print: false,
			libelle_tarif: "",
			tarif_prestations: [],
			p_data_type: ''
		}
	},

	watch: {
		assurance_select() {
			this.choixAssurance()
		}
	},

	computed: {
		tarif_consultations_generalistes() {
            return this.$store.getters["tarif_consultations_generalistes"];
        },

		tarif_consltations_specialistes() {
            return this.$store.getters["tarif_consltations_specialistes"];
        },

		tarif_analyses() {
            return this.$store.getters["tarif_analyses"];
        },

		tarif_examen_para() {
            return this.$store.getters["tarif_examen_para"];
        },

		tarif_chirurgies() {
            return this.$store.getters["tarif_chirurgies"];
        },

		tarif_medicaments() {
            return this.$store.getters["tarif_medicaments"];
        },

		rows() {
            return this.tarif_consultations_generalistes.length;
        },

		tarif_consult_spec_rows() {
            return this.tarif_consltations_specialistes.length;
        },

		tarif_analyse_rows() {
            return this.tarif_analyses.length;
        },

		tarif_exam_rows() {
            return this.tarif_examen_para.length;
        },

		tarif_chirurgie_rows() {
            return this.tarif_chirurgies.length;
        },

		tarif_medicament_rows() {
            return this.tarif_medicaments.length;
        },

		prix_unitaire_cat_onmt() {
            return this.$store.getters["prix_unitaire_cat_onmt"];
        },

		groupe_assurs() {
            return this.$store.getters["groupe_assurs"];
        },

		assurance_sans_groupe() {
            return this.$store.getters["assurance_sans_groupe"];
        },

		tarif_bilan_sante() {
            return this.$store.getters["tarif_bilan_sante"];
        },

		tarif_bilan_sante_rows() {
            return this.tarif_bilan_sante.length;
        },
	},
	mounted() {
		this.$store.dispatch("getGroupeAssurance").then(() => {
			let select_autre = {
				groupe_id: 0,
				groupe: 'Autre'
			}
			this.groupe_assurs.push(select_autre)
		})

		this.$store.dispatch("getAssuranceSansGroupe").then(() => {
			let all_assur = {
				compagnie_id: 0,
				compagnie: 'Toutes les assurances'
			}

			const sans_assur = {
				compagnie_id: -1,
				compagnie: 'Pas d\'assurance'
			}
			this.assurance_sans_groupe.push(all_assur)
			this.assurance_sans_groupe.push(sans_assur)
		})

		/**
		 * Liste des tarifications Consultation généraliste
		 */
		this.$store.dispatch("getTarifConsultationsByCategorie", { categorie_id: 1 }).then(() => {
			this.tarif_gen_loading = false
			if(this.tarif_consultations_generalistes.length > 0) {
				this.tarif_gen_empty = false
			} else {
				this.tarif_gen_empty = true
			}
		});

		/**
		 * Liste des tarifications Consultation spécialiste
		 */
		this.$store.dispatch("getTarifConsultationsByCategorie", { categorie_id: 2 }).then(() => {
			this.tarif_spec_loading = false
			if(this.tarif_consltations_specialistes.length > 0) {
				this.tarif_spec_empty = false
			} else {
				this.tarif_spec_empty = true
			}
		});

		/**
		 * Liste des tarifications ANALYSES
		 */
		this.$store.dispatch("getTarifAnalyse", { groupe_assur_id: 0, assur_id: 0 }).then(() => {
			this.tarif_analyse_loading = false
			if(this.tarif_analyses.length > 0) {
				this.tarif_analyse_empty = false
			} else {
				this.tarif_analyse_empty = true
			}
		});

		/**
		 * Liste des tarifications CHIRURGIES
		 */
		this.$store.dispatch("getTarifChirurgie", { groupe_assur_id: 0, assur_id: 0 }).then(() => {
			this.tarif_chirurgie_loading = false
			if(this.tarif_chirurgies.length > 0) {
				this.tarif_chirurgie_empty = false
			} else {
				this.tarif_chirurgie_empty = true
			}
		});

		this.$store.dispatch("getTarifExamenPara", { groupe_assur_id: 0, assur_id: 0 }).then(() => {
			this.tarif_exam_loading = false
			if(this.tarif_examen_para.length > 0) {
				this.tarif_exam_empty = false
			} else {
				this.tarif_exam_empty = true
			}
		});

		/**
		 * Liste de médicaments
		 */
		this.$store.dispatch("getTarifMedicament", { groupe_assur_id: 0, assur_id: 0 }).then(() => {
			this.tarif_medicament_loading = false
			if(this.tarif_medicaments.length > 0) {
				this.tarif_medicament_empty = false
			} else {
				this.tarif_medicament_empty = true
			}
		});

		/**
		 * Liste Bilan santé
		 */
		this.$store.dispatch("getTarifBilanSante", { groupe_assur_id: 0, assur_id: 0 }).then(() => {
			this.tarif_bilan_sante_loading = false
			if(this.tarif_bilan_sante.length > 0) {
				this.tarif_bilan_sante_empty = false
			} else {
				this.tarif_bilan_sante_empty = true
			}
		});

		var d = new Date()
		var tmpstamp = d.getHours()+''+d.getMinutes()+''+d.getFullYear()

		this.filename = 'Tarification_prestation_'+tmpstamp
	},
	methods: {
		formatNumbers(num) {
            return new Number(num).toLocaleString("fr-FR");
        },

		toutSelectionner() {
            let is_checked = $('#assur-tous').is(":checked")

            if (is_checked) {
                this.one_is_checked = []

                this.assurance_sans_groupe.forEach((data) => {
                    this.one_is_checked.push(data.compagnie_id)
                });
                this.all_checked = true
                
            } else {
                this.one_is_checked = []
                this.all_checked = false
            }
        },

        onOneChange() {
            // let is_checked = $('#assur'+index).is(":checked")

            // let c = ''
            // if (is_checked == true) {
            //     c = 'text-grey'
            // }
            // this.text_grey[index] = c

            document.getElementById("assur-tous").checked = false;
        },

		choixAssurance() {
			this.can_show_param_pu = false
			let compagnie = (this.assurance_select.compagnie_id > 0)?this.assurance_select.compagnie:''

			if (this.assurance_select.compagnie_id == 0) {
				this.is_all_assur = true
			} else {
				this.is_all_assur = false
			}

			if (this.assurance_select.compagnie_id == -1) {
				this.can_show_prix = false
				this.show_prix = 0

				this.fields = [
					'prestations', { key: 'prix_non_assure', label: 'Prix (non assuré)' },
					'actions'
				]

				this.p_fields = [
					'prestations', { key: 'prix_non_assure', label: 'Prix (non assuré)' }, 'actions'
				]

				this.fields_chirurg = [
					'prestations', {key: 'coef', label: 'K (Qté)'}, { key: 'prix_non_assure', label: 'Prix (non assuré)' },
					'actions'
				],
				this.p_fields_chirurg = [
					'prestations', {key: 'coef', label: 'K (Qté)'}, { key: 'prix_non_assure', label: 'Prix (non assuré)' },
					'actions'
				]
			} else {
				if (this.can_set_pac) {
					this.fields = [
						'prestations', { key: 'prix_non_assure', label: 'Prix (non assuré)' },
						{ key: 'prix_assure_clinique', label: 'Prix assuré' },
						{ key: 'prix_assur', label: 'Base '+compagnie }, 
						{ key: 'code_prod_assurance', label: 'Code assur.' }, 'actions'
					]

					this.p_fields = [
						'prestations', { key: 'prix_non_assure', label: 'Prix (non assuré)' },
						{ key: 'prix_assure_clinique', label: 'Prix assuré' },
						{ key: 'prix_assur', label: 'Base '+compagnie }, { key: 'code_prod_assurance', label: 'Code assur.' },
					]

					this.fields_chirurg = [
						'prestations', {key: 'coef', label: 'K (Qté)'}, { key: 'prix_non_assure', label: 'Prix (non assuré)' },
						{ key: 'prix_assure_clinique', label: 'Prix assuré' }, 
						{ key: 'prix_assur', label: 'Base '+compagnie }, 
						{ key: 'code_prod_assurance', label: 'Code assur.' }, 'actions'
					],
					this.p_fields_chirurg = [
						'prestations', {key: 'coef', label: 'K (Qté)'}, { key: 'prix_non_assure', label: 'Prix (non assuré)' },
						{ key: 'prix_assure_clinique', label: 'Prix assuré' }, { key: 'prix_assur', label: 'Base '+compagnie },
						{ key: 'code_prod_assurance', label: 'Code assur.' }
					]
				} else {
					this.fields = [
						'prestations', { key: 'prix_non_assure', label: 'Prix (non assuré)' },
						{ key: 'prix_assur', label: 'Base '+compagnie }, 
						{ key: 'code_prod_assurance', label: 'Code assur.' }, 
						{ key: 'code_prod_assurance', label: 'Code assur.' }, 'actions'
					]

					this.p_fields = [
						'prestations', { key: 'prix_non_assure', label: 'Prix (non assuré)' },
						{ key: 'prix_assur', label: 'Base '+compagnie }, { key: 'code_prod_assurance', label: 'Code assur.' }
					]

					this.fields_chirurg = [
						'prestations', {key: 'coef', label: 'K (Qté)'}, { key: 'prix_non_assure', label: 'Prix (non assuré)' },
						{ key: 'prix_assur', label: 'Base '+compagnie }, 
						{ key: 'code_prod_assurance', label: 'Code assur.' }, 'actions'
					],
					this.p_fields_chirurg = [
						'prestations', {key: 'coef', label: 'K (Qté)'}, { key: 'prix_non_assure', label: 'Prix (non assuré)' },
						{ key: 'prix_assur', label: 'Base '+compagnie }, { key: 'code_prod_assurance', label: 'Code assur.' },
					]
				}
				this.show_prix = 3
			}
			
			
			this.refreshConsultation(1)
			this.refreshConsultation(2)
			this.refreshPrestation('analyse')
			this.refreshPrestation('chirurgie')
			this.refreshPrestation('examen')
			this.refreshPrestation('medicament')
			this.refreshPrestation('bilan_sante')
		},

		/**
		 * Prix unitaire CAT / ONMT
		 * @param {*} slug_prestation 
		 */
		getPrixUnitairePrestation(slug_prestation) {
			this.pu_loading = true

			this.type_prestation_to_add = slug_prestation
			let filter = {
				slug_prestation: slug_prestation,
				groupe_id: this.group_assur_select.groupe_id,
				assurance_id: this.assurance_select.compagnie_id
			}
			this.$store.dispatch("getPrixUnitaireCatOnmt", filter).then(() => {
				this.pu_loading = false

				this.pu_cat_onmt = {
					type_prestation: this.type_prestation_to_add,
					id: this.prix_unitaire_cat_onmt.id,
					libelle: this.prix_unitaire_cat_onmt.libelle,
					lettre_cle: this.prix_unitaire_cat_onmt.lettre_cle,
					pu_cat: this.prix_unitaire_cat_onmt.pu_cat,
					pu_onmt: this.prix_unitaire_cat_onmt.pu_onmt,
					pu_inam: this.prix_unitaire_cat_onmt.pu_inam,
					groupe_assur_id: {
						groupe_id: this.group_assur_select.groupe_id,
						groupe: this.group_assur_select.groupe
					},
					assurance_id: {
						compagnie: this.assurance_select.compagnie,
						compagnie_id: this.assurance_select.compagnie_id
					}
				}
			});
		},

		refreshConsultation(categorie_id) {
			if(categorie_id == 1) {
				this.tarif_gen_loading = true
			} else {
				this.tarif_spec_loading = true
			}

			let groupe_assur_id = (this.group_assur_select.groupe_id > 0)?this.group_assur_select.groupe_id:0
			let assur_id = (this.assurance_select.compagnie_id > 0)?this.assurance_select.compagnie_id:0
			this.$store.dispatch("getTarifConsultationsByCategorie", { 
				categorie_id: categorie_id, groupe_assur_id: groupe_assur_id, 
				assur_id: assur_id
			}).then(() => {
				if(categorie_id == 1) {
					this.tarif_gen_loading = false
					if(this.tarif_consultations_generalistes.length > 0) {
						this.tarif_gen_empty = false
					} else {
						this.tarif_gen_empty = true
					}
				} else {
					this.tarif_spec_loading = false
					if(this.tarif_consltations_specialistes.length > 0) {
						this.tarif_spec_empty = false
					} else {
						this.tarif_spec_empty = true
					}
				}
			});
		},

		refreshPrestation(type_prestation) {
			if (type_prestation == 'analyse') {
				this.tarif_analyse_loading = true
				let groupe_assur_id = (this.group_assur_select.groupe_id > 0)?this.group_assur_select.groupe_id:0
				let assur_id = (this.assurance_select.compagnie_id > 0)?this.assurance_select.compagnie_id:0
				this.$store.dispatch("getTarifAnalyse", { groupe_assur_id: groupe_assur_id, assur_id: assur_id }).then(() => {
					this.tarif_analyse_loading = false
					if(this.tarif_analyses.length > 0) {
						this.tarif_analyse_empty = false
					} else {
						this.tarif_analyse_empty = true
					}
				});
			} else if (type_prestation == 'chirurgie') {
				this.tarif_chirurgie_loading = true

				let groupe_assur_id = (this.group_assur_select.groupe_id > 0)?this.group_assur_select.groupe_id:0
				let assur_id = (this.assurance_select.compagnie_id > 0)?this.assurance_select.compagnie_id:0
				this.$store.dispatch("getTarifChirurgie", { groupe_assur_id: groupe_assur_id, assur_id: assur_id }).then(() => {
					this.tarif_chirurgie_loading = false
					if(this.tarif_chirurgies.length > 0) {
						this.tarif_chirurgie_empty = false
					} else {
						this.tarif_chirurgie_empty = true
					}
				});
			} else if (type_prestation == 'examen') {
				this.tarif_exam_loading = true

				let groupe_assur_id = (this.group_assur_select.groupe_id > 0)?this.group_assur_select.groupe_id:0
				let assur_id = (this.assurance_select.compagnie_id > 0)?this.assurance_select.compagnie_id:0
				this.$store.dispatch("getTarifExamenPara", { groupe_assur_id: groupe_assur_id, assur_id: assur_id }).then(() => {
					this.tarif_exam_loading = false
					if(this.tarif_examen_para.length > 0) {
						this.tarif_exam_empty = false
					} else {
						this.tarif_exam_empty = true
					}
				});
			} else if (type_prestation == 'medicament') {
				this.tarif_medicament_loading = true

				let groupe_assur_id = (this.group_assur_select.groupe_id > 0)?this.group_assur_select.groupe_id:0
				let assur_id = (this.assurance_select.compagnie_id > 0)?this.assurance_select.compagnie_id:0
				this.$store.dispatch("getTarifMedicament", { groupe_assur_id: groupe_assur_id, assur_id: assur_id }).then(() => {
					this.tarif_medicament_loading = false
					if(this.tarif_examen_para.length > 0) {
						this.tarif_medicament_empty = false
					} else {
						this.tarif_medicament_empty = true
					}
				});
			} else if (type_prestation == 'bilan_sante') {
				this.tarif_bilan_sante_loading = true

				let groupe_assur_id = (this.group_assur_select.groupe_id > 0)?this.group_assur_select.groupe_id:0
				let assur_id = (this.assurance_select.compagnie_id > 0)?this.assurance_select.compagnie_id:0
				this.$store.dispatch("getTarifBilanSante", { groupe_assur_id: groupe_assur_id, assur_id: assur_id }).then(() => {
					this.tarif_bilan_sante_loading = false
					if(this.tarif_bilan_sante.length > 0) {
						this.tarif_bilan_sante_empty = false
					} else {
						this.tarif_bilan_sante_empty = true
					}
				});
			}
		},

		onFilterTarif() {
			let id_selected = this.filtre_tarif.id

			if (id_selected > 0) {
				for(let i = 1; i <= this.tarif_filter.length; i++) {
					if (i != id_selected ) {
						$('.tarif-'+i).fadeOut(500)
					}
				}
				setTimeout(() => {
					$('.tarif-'+id_selected ).fadeIn(500)
				}, 500);
			} else {
				for(let i = 1; i <= this.tarif_filter.length; i++) {
					$('.tarif-'+i).fadeIn(500)
				}
			}
			
		},

		/**
		 * Ajouter un type de prestation
		 * @param {*} categorie_consultation 
		 * @param {*} type_prestation 
		 */
		addPrestation (categorie_consultation, type_prestation) {
			this.is_new = true
			this.is_edit = false
			this.type_prestation_to_add = type_prestation

			this.c_prestation = {
				type_consultation_id: 0,
				categorie_consultation: categorie_consultation,
				id: 0,
				libelle: '',
				lettre_cle: '',
				coef: '',
				moment: {
					id: 1,
					denomination: 'Jour'
				},
				prix_non_assure: '',
				prix_assure_clinique: '',
				groupe_assur_id: {
					groupe_id: this.group_assur_select.groupe_id,
					groupe: this.group_assur_select.groupe
				},
				assurance_id: {
					compagnie: this.assurance_select.compagnie,
					compagnie_id: this.assurance_select.compagnie_id
				},
				code_prod_assurance: ''
			}

			if (type_prestation == 'consultation') {
				this.can_add_moment = true
				this.can_add_coef = false
				this.can_show_prix = true
				this.can_show_lettre_cle = true
			} else {
				this.can_add_moment = false
				this.can_add_coef = true
				this.can_show_prix = false
				this.can_show_lettre_cle = false
			}
			
		},

		clearError() {
			this.is_zero = false
		},

		editTarifPrestation(tarif_data) {
			this.edit(tarif_data.data, tarif_data.type_prestation)
		},

		closeTarifModal() {
			this.save_loading = false
			this.btn_disable = false
			this.$refs.modal_prestation.click()
		},

		editTarifActe(tarif_data) {
			this.edit(tarif_data.data, tarif_data.type_prestation)
		},

		edit (data, type_prestation) {
			this.is_edit = true
			this.type_prestation_to_add = type_prestation
			this.can_show_lettre_cle = true

			this.can_show_prix = true
			this.one_is_checked = []
			this.all_checked = false
			this.text_grey = []
			// document.getElementById("assur-tous").checked = false;

			if (type_prestation == 'consultation') {
				this.is_new = false
				this.can_add_moment = true
				this.can_add_coef = false

				this.c_prestation = {
					type_consultation_id: data.type_consultation_id,
					categorie_consultation: data.categorie_consultation_id,
					id: data.id,
					libelle: data.nom_prestation,
					lettre_cle: (data.lettre_cle == '-')?'':data.lettre_cle,
					coef: (data.coefficient == '-')?'':data.coefficient,
					moment: {
						id: data.moment_id,
						denomination: data.moment
					},
					prix_non_assure: data.prix_non_assure,
					prix_assure_clinique: data.prix_assure_clinique,
					prix_assur: data.prix_assur,
					groupe_assur_id: {
						groupe_id: this.group_assur_select.groupe_id,
						groupe: this.group_assur_select.groupe
					},
					assurance_id: {
						compagnie: this.assurance_select.compagnie,
						compagnie_id: this.assurance_select.compagnie_id
					},
					code_prod_assurance: data.code_prod_assurance
				}
			} else if (type_prestation == 'analyse') {
				this.is_new = true
				this.can_add_moment = false
				this.can_add_coef = false

				this.c_prestation = {
					type_consultation_id: 0,
					categorie_id: data.categorie_id,
					id: data.id,
					libelle: data.nom_prestation,
					lettre_cle: (data.lettre_cle == '-')?'':data.lettre_cle,
					coef: (data.coefficient == '-')?'':data.coefficient,
					moment: {
						id: 0,
						denomination: ''
					},
					prix_non_assure: data.prix_non_assure,
					prix_assure_clinique: data.prix_assure_clinique,
					prix_assur: data.prix_assur,
					groupe_assur_id: {
						groupe_id: this.group_assur_select.groupe_id,
						groupe: this.group_assur_select.groupe
					},
					assurance_id: {
						compagnie: this.assurance_select.compagnie,
						compagnie_id: this.assurance_select.compagnie_id
					},
					code_prod_assurance: data.code_prod_assurance
				}
			} else if (type_prestation == 'examen') {
				this.is_new = true
				this.can_add_moment = false
				this.can_add_coef = false

				this.c_prestation = {
					id: data.id,
					libelle: data.nom_prestation,
					lettre_cle: (data.lettre_cle == '-')?'':data.lettre_cle,
					coef: (data.coefficient == '-')?'':data.coefficient,
					moment: {
						id: 0,
						denomination: ''
					},
					prix_non_assure: data.prix_non_assure,
					prix_assure_clinique: data.prix_assure_clinique,
					prix_assur: data.prix_assur,
					groupe_assur_id: {
						groupe_id: this.group_assur_select.groupe_id,
						groupe: this.group_assur_select.groupe
					},
					assurance_id: {
						compagnie: this.assurance_select.compagnie,
						compagnie_id: this.assurance_select.compagnie_id
					},
					code_prod_assurance: data.code_prod_assurance
				}
			}  else if (type_prestation == 'acte') {
				this.is_new = true
				this.can_add_moment = false
				this.can_add_coef = false

				this.c_prestation = {
					id: data.id,
					libelle: data.nom_prestation,
					lettre_cle: (data.lettre_cle == '-')?'':data.lettre_cle,
					coef: (data.coefficient == '-')?'':data.coefficient,
					moment: {
						id: 0,
						denomination: ''
					},
					prix_non_assure: (data.prix_non_assure == '-')?'':data.prix_non_assure,
					prix_assure_clinique: data.prix_assure_clinique,
					prix_assur: data.prix_assur,
					groupe_assur_id: {
						groupe_id: 0,
						groupe: ''
					},
					assurance_id: {
						compagnie: this.assurance_select.compagnie,
						compagnie_id: this.assurance_select.compagnie_id
					},
					code_prod_assurance: data.code_prod_assurance
				}
			} else if (type_prestation == 'medicament') {
				this.is_new = false
				this.can_add_moment = false
				this.can_add_coef = false
				this.can_show_lettre_cle = false

				this.c_prestation = {
					id: data.id,
					libelle: data.nom_prestation,
					lettre_cle: (data.lettre_cle == '-')?'':data.lettre_cle,
					coef: (data.coefficient == '-')?'':data.coefficient,
					moment: {
						id: 0,
						denomination: ''
					},
					prix_non_assure: data.prix_non_assure,
					prix_assure_clinique: data.prix_assure_clinique,
					prix_assur: data.prix_assur,
					groupe_assur_id: {
						groupe_id: this.group_assur_select.groupe_id,
						groupe: this.group_assur_select.groupe
					},
					assurance_id: {
						compagnie: this.assurance_select.compagnie,
						compagnie_id: this.assurance_select.compagnie_id
					},
					code_prod_assurance: data.code_prod_assurance
				}
			} else if (type_prestation == 'bilan_sante') {
				this.is_new = true
				this.can_add_moment = false
				this.can_add_coef = false

				this.c_prestation = {
					id: data.id,
					libelle: data.libelle,
					lettre_cle: '',
					coef: '',
					moment: {
						id: 0,
						denomination: ''
					},
					prix_non_assure: data.pu,
					prix_assure_clinique: data.prix_assure_clinique,
					prix_assur: data.prix_assur,
					groupe_assur_id: {
						groupe_id: this.group_assur_select.groupe_id,
						groupe: this.group_assur_select.groupe
					},
					assurance_id: {
						compagnie: this.assurance_select.compagnie,
						compagnie_id: this.assurance_select.compagnie_id
					},
					code_prod_assurance: data.code_prod_assurance
				}
			} else if (
				type_prestation == 'acte' || type_prestation == 'chambre' || type_prestation == 'observation' || 
				type_prestation == 'admission' || type_prestation == 'consommable'
			) {
				this.is_new = true
				this.can_add_moment = false
				this.can_add_coef = false

				this.c_prestation = {
					id: data.id,
					libelle: data.nom_prestation,
					lettre_cle: (data.lettre_cle == '-')?'':data.lettre_cle,
					coef: (data.coefficient == '-')?'':data.coefficient,
					moment: {
						id: 0,
						denomination: ''
					},
					prix_non_assure: (data.prix_non_assure == '-')?'':data.prix_non_assure,
					prix_assure_clinique: data.prix_assure_clinique,
					prix_assur: data.prix_assur,
					groupe_assur_id: {
						groupe_id: 0,
						groupe: ''
					},
					assurance_id: {
						compagnie: this.assurance_select.compagnie,
						compagnie_id: this.assurance_select.compagnie_id
					},
					code_prod_assurance: data.code_prod_assurance
				}
			}
		},

		/**
		 * Edit Tarification Chirurgie
		 */
		editTarifChirurgie(data, chirurgie_id) {
			this.type_prestation_to_add = 'chirurgie'
			this.is_edit = true
			
			this.is_new = false
			this.can_add_moment = false
			this.can_add_coef = true

			this.c_prestation = {
				chirurgie_id: chirurgie_id,
				id: data.k_id,
				libelle: data.k_chirurgie,
				lettre_cle: '',
				coef: (data.k_coef == '-')?'':data.k_coef,
				
				prix_non_assure: (data.pu == null)?'':data.pu,
				prix_assure_clinique: data.prix_assure_clinique,
				prix_assur: data.prix_assur,
				groupe_assur_id: {
					groupe_id: this.group_assur_select.groupe_id,
					groupe: this.group_assur_select.groupe
				},
				assurance_id: {
					compagnie: this.assurance_select.compagnie,
					compagnie_id: this.assurance_select.compagnie_id
				},
				code_prod_assurance: data.code_prod_assurance
			}
		},

		/**
		 * Enregistrer Prestation
		 * @returns 
		 */
		async submitPrestation() {
			const isValid = await this.$refs.observer.validate();
			
            if (!isValid) {
                return;
            }

			if (this.show_prix == 3 && this.can_set_pac) {
				this.c_prestation.prix_assure_clinique = this.cleanNumber(this.c_prestation.prix_assure_clinique)
				this.c_prestation.prix_assur = this.cleanNumber(this.c_prestation.prix_assur)

				if (this.c_prestation.prix_assure_clinique  === 0) {
					this.is_zero = true
					return;
				}
			}

			if (this.c_prestation.prix_assure_clinique == '-' || this.c_prestation.prix_assure_clinique == '') {
				this.c_prestation.prix_assure_clinique = null
			}

			if (this.c_prestation.prix_assur == '-' || this.c_prestation.prix_assur == '') {
				this.c_prestation.prix_assur = null
			}
			
			this.c_prestation.grp_assurances = this.one_is_checked			

			this.save_loading = true
            this.btn_disable = true
			
			if (this.type_prestation_to_add == 'consultation') {
				// ------>>>>>>>>>  ENREGISTREMENT CONSULTATION
				this.$store.dispatch("addConsultationPrestation", this.c_prestation).then((response) => {
					if (response > 0) {
						this.afterSubmission(this.type_prestation_to_add)
						this.refreshConsultation(1)
						this.refreshConsultation(2)
					} else {
						// TODO
						// Afficher msg d'erreur
					}
					this.save_loading = false
					this.btn_disable = false
				})
			} else if (this.type_prestation_to_add == 'analyse') {
				this.$store.dispatch("addAnalysePrestation", this.c_prestation).then((response) => {
					if (response > 0) {
						this.afterSubmission(this.type_prestation_to_add)
					} else {
						// TODO
						// Afficher msg d'erreur
					}
					this.save_loading = false
					this.btn_disable = false
				})
			} else if (this.type_prestation_to_add == 'chirurgie') {
				this.$store.dispatch("addChirurgiePrestation", this.c_prestation).then((response) => {
					if (response > 0) {
						this.afterSubmission(this.type_prestation_to_add)
					} else {
						// TODO
						// Afficher msg d'erreur
					}
					this.save_loading = false
					this.btn_disable = false
				})
			} else if (this.type_prestation_to_add == 'examen') {
				this.$store.dispatch("saveExamenPara", this.c_prestation).then((response) => {
					if (response > 0) {
						this.afterSubmission(this.type_prestation_to_add)
					} else {
						// TODO
						// Afficher msg d'erreur
					}
					this.save_loading = false
					this.btn_disable = false
				})
			} else if (this.type_prestation_to_add == 'medicament') {
				this.$store.dispatch("saveMedicament", this.c_prestation).then((response) => {
					if (response > 0) {
						this.afterSubmission(this.type_prestation_to_add)
					} else {
						// TODO
						// Afficher msg d'erreur
					}
					this.save_loading = false
					this.btn_disable = false
				})
			} else if (this.type_prestation_to_add == 'bilan_sante') {
				this.$store.dispatch("saveTarifBilanSante", this.c_prestation).then((response) => {
					if (response > 0) {
						this.afterSubmission(this.type_prestation_to_add)
					} else {
						// TODO
						// Afficher msg d'erreur
					}
					this.save_loading = false
					this.btn_disable = false
				})
			} else if (this.type_prestation_to_add == 'acte') {
				this.editing_acte_tarif_data = this.c_prestation
			} else if (this.type_prestation_to_add == 'chambre') {
				this.editing_chambre_tarif_data = this.c_prestation
			} else if (this.type_prestation_to_add == 'observation') {
				this.editing_observation_tarif_data = this.c_prestation
			} else if (this.type_prestation_to_add == 'admission') {
				this.editing_admission_tarif_data = this.c_prestation
			} else if (this.type_prestation_to_add == 'consommable') {
				this.editing_consommable_tarif_data = this.c_prestation
			}
		},

		afterSubmission(type_prestation) {
			this.refreshPrestation(type_prestation);

			if (this.is_new == true) {
				this.successToast('Tarif ajouté avec succès')
			} else {
				this.successToast('Tarif modifié avec succès')
			}
			$('.modal').modal('hide')
			
			this.c_prestation = {
				type_consultation_id: 0,
				categorie_consultation: 0,
				id: 0,
				libelle: '',
				lettre_cle: '',
				coef: '',
				moment: {
					id: 1,
					denomination: 'Jour'
				},
				prix_non_assure: '',
				prix_assure_clinique: '',
				groupe_assur_id: '',
				assurance_id: '',
				code_prod_assurance: ''
			}
		},

		/**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

		/**
		 * Selectionne la prestation de consultation à supprimer
		 * @param {*} data 
		 */
		remove(data) {
			this.tarif_to_be_deleted = {
                tarif_id: data.id,
                libelle: data.nom_prestation+' ( '+data.moment+' )',
            }
			this.del_categorie_consultation = data.categorie_consultation_id
		},

		/**
		 * Retirer un examen de la liste de demande
		 */
        supprimer() {
            this.del_loading = true;

            let confirm = document.getElementById('cfrm-del');
            let err = 0

            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                err++;
                this.del_loading = false;
            }

            if (err == 0) {
                this.$store.dispatch('deleteTarifConsultation', this.tarif_to_be_deleted).then((response) => {
                    
                    if (response > 0) {
                        this.successToast('Tarif supprimé avec succès')
                    }

					this.refreshConsultation(this.del_categorie_consultation);
					$('.modal').modal('hide')
                    this.del_loading = false;
                    this.is_confirm = false
                })
            }
        },

		/**
		 * Save Prix Unitaire CAT / ONMT
		 */
		async submitPrixUnitaire() {
			const isValid = await this.$refs.observer.validate();

            if (!isValid) {
                return;
            }

            this.save_loading = true
            this.btn_disable = true

            this.$store.dispatch("updatePrixCatOnmt", this.pu_cat_onmt).then((response) => {
                if (response > 0) {
					this.successToast('Prix CAT / ONMT modifié avec succès')
					$('.modal').modal('hide')

					if (this.type_prestation_to_add == 'consultation_generaliste') {
						this.refreshConsultation(1)
					} else if (this.type_prestation_to_add == 'consultation_specialiste') {
						this.refreshConsultation(2)
					} else {
						this.refreshPrestation(this.type_prestation_to_add);
					} 
					// else if (this.type_prestation_to_add == 'analyse') {
					// 	this.refreshPrestation(this.type_prestation_to_add);
					// }
                    
                    this.pu_cat_onmt = {
						type_prestation: '',
						id: 0,
						libelle: '',
						lettre_cle: '',
						pu_cat: '',
						pu_onmt: '',
						pu_inam: '',
						groupe_assur_id: '',
						assurance_id: ''
					}
					this.$refs.observer.reset();
                } else {
					// TODO
					// Afficher msg d'erreur
                }
				this.save_loading = false
                this.btn_disable = false
            })
		},

		setToPrint(to_print) {
			
			this.p_printing = to_print

			if (to_print == 'consultation_gen') {
                this.is_printing_consul_gen = true

                setTimeout(() => {
                    this.is_printing_consul_gen = false
                }, 1500);
            } else if (to_print == 'consultation_spec') {
                this.is_printing_consul_spec = true

                setTimeout(() => {
                    this.is_printing_consul_spec = false
                }, 1500);
            } else if (to_print == 'analyse') {
                this.is_printing_analyse = true

                setTimeout(() => {
                    this.is_printing_analyse = false
                }, 1500);
            } else if (to_print == 'examen') {
                this.is_printing_examen = true

                setTimeout(() => {
                    this.is_printing_examen = false
                }, 1500);
            } else if (to_print == 'medicament') { ///////////////////
                this.is_printing_med = true

                setTimeout(() => {
                    this.is_printing_med = false
                }, 1500);
            } else if (to_print == 'chirurgie') {
                this.is_printing_chirurgie = true

                setTimeout(() => {
                    this.is_printing_chirurgie = false
                }, 1500);
            } else if (to_print == 'bilan_sante') {
                this.is_printing_bilan = true

                setTimeout(() => {
                    this.is_printing_bilan = false
                }, 1500);
            }
		},

		setPrestationToPrint(data_type, prestation) {
			console.log(prestation);
			
			const data = {
                data_type: data_type,
                prestations: prestation
            }
			this.printTarifByPrestation(data)
		},

		printTarifByPrestation(data) {
			this.p_data_type = data.data_type
			this.tarif_prestations = data.prestations
			if (data.data_type == 'consommable') {
				this.libelle_tarif = 'Tarif Consommables'
			} else if (data.data_type == 'acte') {
				this.libelle_tarif = 'Tarif Actes'
			} else if (data.data_type == 'chambre') {
				this.libelle_tarif = 'Tarif Chambres'
			} else if (data.data_type == 'observation') {
				this.libelle_tarif = 'Tarif Observations'
			} else if (data.data_type == 'admission') {
				this.libelle_tarif = 'Tarif Admissions'
			} else if (data.data_type == 'bilan_sante') {
				this.libelle_tarif = 'Bilan de santé'
			} else if (data.data_type == 'medicament') {
				this.libelle_tarif = 'Tarif Médicaments'
			} else if (data.data_type == 'examen') {
				this.libelle_tarif = 'Tarif Examens'
			} else if (data.data_type == 'analyse') {
				this.libelle_tarif = 'Tarif Analyses'
			} else if (data.data_type == 'consultation_spec') {
				this.libelle_tarif = 'Tarif Consultations spécialistes'
			} else if (data.data_type == 'consultation_gen') {
				this.libelle_tarif = 'Tarif Consultations spécialistes'
			} else if (data.data_type == 'chirurgie') {
				this.libelle_tarif = 'Tarif Chirurgies'
			}			

			this.can_print = true
            setTimeout(() => {
                window.print()

                this.can_print = false
            }, 500);
		}
	}
}


